import Amenity from "../../../models/amenity";
import {Select} from "@blueprintjs/select";
import {Button, Classes, MenuItem} from "@blueprintjs/core";
import React, {useState} from "react";

interface Props {
  amenity?: Amenity;
  onChange: (amenity: Amenity) => void;
}

const AppleAmenitySelect = Select.ofType<string>()

export function IMDFAmenitySelect({ amenity, onChange }: Props) {
  const [query, setQuery] = useState('');

  const onSelect = (imdfAmenity: string) => {
    const _amenity = new Amenity(amenity);
    _amenity.imdf = imdfAmenity;
    onChange(_amenity)
  }

  return (
    <AppleAmenitySelect
      onItemSelect={onSelect}
      items={IMDFAmenities.filter(i => i.toLowerCase().includes(query.toLowerCase()))}
      popoverProps={{ minimal: true, usePortal: false }}
      filterable={true}
      onQueryChange={setQuery}
      query={query}
      itemRenderer={(item, options) =>
        <MenuItem
          key={`category-select-${item}`}
          text={item}
          onClick={options.handleClick}
        />
      }>
      <Button
        className={Classes.MINIMAL}
        text={amenity?.imdf ? amenity.imdf : 'Select IMDF Amenity Category'}
        style={{ marginRight: 20 }}
        rightIcon={"chevron-down"}
      />
    </AppleAmenitySelect>
  );
}

const IMDFAmenities = [
  "amphitheater",
  "animalreliefarea",
  "arrivalgate",
  "atm",
  "babychanging",
  "baggagecarousel",
  "baggagecarousel.intl",
  "baggagecarts",
  "baggageclaim",
  "baggageclaim.oversize",
  "baggagerecheck",
  "baggagestorage",
  "boardinggate",
  "boardinggate.aircraft",
  "boardinggate.bus",
  "boardinggate.ferry",
  "boardinggate.train",
  "bus",
  "bus.muni",
  "bus.national",
  "businesscenter",
  "cabin",
  "caregiver",
  "carrental",
  "cashier",
  "changemachine",
  "checkin",
  "checkin.desk",
  "checkin.desk.oversizebaggage",
  "checkin.desk.transfer",
  "checkin.selfservice",
  "childplayarea",
  "coinlocker",
  "copymachine",
  "defibrillator",
  "drinkingfountain",
  "eatingdrinking",
  "elevator",
  "emergencyshelter",
  "entry",
  "escalator",
  "exhibit",
  "faregate",
  "faregate.oversized",
  "fieldofplay",
  "fieldofplay.americanfootball",
  "fieldofplay.baseball",
  "fieldofplay.basketball",
  "fieldofplay.fieldhockey",
  "fieldofplay.icehockey",
  "fieldofplay.rugby",
  "fieldofplay.soccer",
  "fieldofplay.softball",
  "fieldofplay.tennis",
  "fieldofplay.trackfield",
  "fieldofplay.volleyball",
  "firealarmpullstation",
  "fireextinguisher",
  "firstaid",
  "fittingroom",
  "foodservice",
  "gatearea",
  "groundtransportation",
  "guestservices",
  "handsanitizerstation",
  "healthscreening",
  "hoteling",
  "immigration",
  "information",
  "information.bid",
  "information.carrental",
  "information.hotel",
  "information.mufid",
  "information.mufid.arrivals",
  "information.mufid.departures",
  "information.transit",
  "landmark",
  "library",
  "limo",
  "lostandfound",
  "mailbox",
  "meditation",
  "meetingpoint",
  "mobilityrescue",
  "mothersroom",
  "movingwalkway",
  "paidarea",
  "parkandride",
  "parking",
  "parking.bicycle",
  "parking.compact",
  "parking.ev",
  "parking.longterm",
  "parking.motorcycle",
  "parking.shortterm",
  "parking.waitingarea",
  "payphone",
  "pedestriancrossing",
  "peoplemover",
  "phone",
  "phone.emergency",
  "photobooth",
  "platform",
  "police",
  "powerchargingstation",
  "prayerroom",
  "prayerroom.buddhism",
  "prayerroom.christianity",
  "prayerroom.hinduism",
  "prayerroom.islam",
  "prayerroom.islam.female",
  "prayerroom.islam.male",
  "prayerroom.judaism",
  "prayerroom.shintoism",
  "prayerroom.sikh",
  "prayerroom.taoic",
  "privatelounge",
  "productreturn",
  "rail.muni",
  "rail.national",
  "ramp",
  "reception.desk",
  "recreation",
  "restroom",
  "restroom.family",
  "restroom.female",
  "restroom.female.wheelchair",
  "restroom.male",
  "restroom.male.wheelchair",
  "restroom.transgender",
  "restroom.transgender.wheelchair",
  "restroom.unisex",
  "restroom.unisex.wheelchair",
  "restroom.wheelchair",
  "rideshare",
  "seat",
  "seating",
  "security",
  "security.checkpoint",
  "security.inspection",
  "service",
  "shower",
  "shuttle",
  "sleepbox",
  "smokingarea",
  "stairs",
  "storage",
  "strollerrental",
  "studentadmissions",
  "studentservices",
  "swimmingpool",
  "swimmingpool.children",
  "swimmingpool.family",
  "taxi",
  "ticketing",
  "ticketing.airline",
  "ticketing.bus",
  "ticketing.bus.muni",
  "ticketing.bus.national",
  "ticketing.rail",
  "ticketing.rail.muni",
  "ticketing.rail.national",
  "ticketing.shuttle",
  "traintrack",
  "transit",
  "unspecified",
  "valet",
  "vendingmachine",
  "vendingmachine.trainticket",
  "wheelchairassist",
  "wifi",
  "yoga",
]
